/*******************************************************************************
  CreateSite.js

  Author: Advait

 This file  is responsible for creating new sites for Facilities.
 For initial phases, we also creating 14 schedule items for each site

 Current code is developed by newbie developer, so may not be standard
*******************************************************************************/
import React, { Component } from "react";
import { createScheduleItem } from "../graphql/mutations";
import SelectTenant from "../components/SelectTenant";
import TenantSiteStatus from "../components/TenantSiteStatus";
import { showNotification } from "../components/helper/notification";
import { connect } from "react-redux";
import "../index.css";
import { API, graphqlOperation } from "aws-amplify";

// Similar to createSite in graphql/mutations.js, but this doesn't ask
// for restricted fields to be returned.
const createSiteSafe = /* GraphQL */ `
  mutation CreateSite($input: CreateSiteInput!) {
    createSite(input: $input) {
      id
      tid
      siteName
      rmsName
      mapName
      emailsToNotify
      alarmThresholds
      ScheduleItems {
        items {
          id
          siteId
          enabled
          type
          day
          startTime
          duration
          tid
          createdAt
          updatedAt
        }
        nextToken
      }
      buildingAlarmIntegrated
      buildingAlarmState
      timezone
      recharge_threshold_min
      recharge_threshold_max
      restrict_ui_page
      disabled
      securityRound_action
      securityRound_wait_time
      allow_securityRound_tpapp
      include_tags_in_round
      allow_image_store
      createdAt
      updatedAt
    }
  }
`;

class CreateSite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      createSiteName: "",
      createRmsName: "",
      createMapName: "",
      createButtonDisabled: true,
    };
    this.handleCreateSite = this.handleCreateSite.bind(this);
    this.handleChangeSiteName = this.handleChangeSiteName.bind(this);
    this.handleChangeRmsName = this.handleChangeRmsName.bind(this);
    this.handleChangeMapName = this.handleChangeMapName.bind(this);
    this.handleCreateScheduleItems = this.handleCreateScheduleItems.bind(this);
  }

  async handleCreateSite(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ createButtonDisabled: true });
    if (!this.props.selectedTenantId) {
      alert("Please select a tenant");
      this.setState({ createButtonDisabled: false });
    } else if (
      this.state.createSiteName === "" ||
      this.state.createRmsName === "" ||
      this.state.createMapName === ""
    ) {
      alert("Please enter all fields");
      this.setState({ createButtonDisabled: false });
    } else {
      const site = {
        siteName: this.state.createSiteName,
        tid: this.props.selectedTenantId,
        tenantSitesId: this.props.selectedTenantId,
        rmsName: this.state.createRmsName,
        mapName: this.state.createMapName,
        alarmThresholds: '{"wifi": {}}',
        uvRestrictHours: false, // not used anymore, set default value anyway
        buildingAlarmIntegrated: false,
        buildingAlarmState: "UV_ALLOWED", // not used anymore, set default value anyway
        restrict_ui_page:
          '{"inspection": false, "security_patrol": false, "reception": false}',
        disabled: false,
        securityRound_action: "NONE",
        securityRound_wait_time: 0,
        allow_securityRound_tpapp: false,
      };
      try {
        const response = await API.graphql(graphqlOperation(createSiteSafe, { input: site }));
        console.log("response", response);
        console.log("id", response.data.createSite.id, "tid", response.data.createSite.tid);
        if (response !== "") {
          this.handleCreateScheduleItems(
            response.data.createSite.id,
            response.data.createSite.tid
          );
          showNotification(true, `Site "${this.state.createSiteName}" created successfully`);
        }
        this.setState({
          createSiteName: "",
          createRmsName: "",
          createMapName: "",
          createButtonDisabled: true,
        });
      } catch (e) {
        console.log(e);
        showNotification(false, `Failed to create site "${this.state.createSiteName}".`);
        this.setState({ createButtonDisabled: false });
      }
    }
  }

  handleChangeSiteName(event) {
    const siteName = event.target.value;
    this.setState({
      createSiteName: siteName,
      createButtonDisabled: siteName.trim() === "",
    });
  }

  handleChangeMapName(event) {
    this.setState({
      createMapName: event.target.value,
      createButtonDisabled: this.state.createSiteName.trim() === "",
    });
  }

  handleChangeRmsName(event) {
    this.setState({
      createRmsName: event.target.value,
      createButtonDisabled: this.state.createSiteName.trim() === "",
    });
  }
  //***************************************************************************
  // create 7 schedule for each mode.
  //***************************************************************************
  async handleCreateScheduleItems(siteID, tenantId) {
    var i = 0;
    do {
      // First 7 schedules are for reception, next 7 are inspection, next 7 security patrol
      // Only reception and security patrol has a duration
      let ScheduleItem = {
        siteId: siteID,
        enabled: false,
        day: (i % 7).toString(),
        startTime: "8:00",
        tid: tenantId,
      };
      if (i < 7) {
        ScheduleItem.type = "reception";
        ScheduleItem.duration = "5:00";
      } else if (i < 14) {
        ScheduleItem.type = "inspection";
      } else if (i < 21) {
        ScheduleItem.type = "security_patrol";
        ScheduleItem.startTime = "00:30";
        ScheduleItem.duration = "4:00";
      }
      try {
        const response = await API.graphql(
          graphqlOperation(createScheduleItem, { input: ScheduleItem })
        );
        console.log("response", response);
        if (response !== "") {
          console.log("schedule created successfully.");
        }
      } catch (e) {
        console.log(e);
      }

      i++;
    } while (i < 21);
  }

  render() {
    return (
      <div className="fullPageDiv">
        <h3>Manage Site</h3>
        <SelectTenant />

        {this.props.selectedTenantId ? (
          <>
            <div className="individualContainer">
              <form onSubmit={this.handleCreateSite}>
                <table className="individualContainerTable">
                  <tbody>
                    <tr>
                      <td className="individualContainerTitleColumn" valign="top">
                        <h4 className="individualContainerTitleHeading">Create Site</h4>
                      </td>
                      <td>
                        <table>
                          <tbody>
                            <tr>
                              <td
                                className="individualContainerSubTitleColumn"
                                style={{ verticalAlign: "middle" }}
                              >
                                <h6>Site Name</h6>
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                <input
                                  className="inputFieldSelect"
                                  style={{ paddingLeft: "5px" }}
                                  type="text"
                                  placeholder="Site Name"
                                  value={this.state.createSiteName}
                                  onChange={this.handleChangeSiteName}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="individualContainerSubTitleColumn"
                                style={{ verticalAlign: "middle" }}
                              >
                                <h6>RMS Name</h6>
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                <input
                                  className="inputFieldSelect"
                                  style={{ paddingLeft: "5px" }}
                                  type="text"
                                  placeholder="RMS Name"
                                  value={this.state.createRmsName}
                                  onChange={this.handleChangeRmsName}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="individualContainerSubTitleColumn"
                                style={{ verticalAlign: "middle" }}
                              >
                                <h6>Map Name</h6>
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                <input
                                  className="inputFieldSelect"
                                  style={{ paddingLeft: "5px" }}
                                  type="text"
                                  placeholder="Map Name"
                                  value={this.state.createMapName}
                                  onChange={this.handleChangeMapName}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td className="individualContainerTitleColumn" valign="top"></td>
                      <td style={{ padding: "0 0 15px 0" }}>
                        <button
                          className="saveButton"
                          type="submit"
                          disabled={this.state.createButtonDisabled}
                        >
                          Create
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </form>
            </div>
            <TenantSiteStatus entityType="site" tenantId={this.props.selectedTenantId} />
          </>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedTenantId: state.selectedSite.tenantId,
});

export default connect(mapStateToProps)(CreateSite);
